module.controller('addressFormCntrl', function(xmppAuth, services, $scope, $mdToast, $mdDialog, $window, $q, theme, $localStorage, $cookieStore) {

  var xmpp_domain = $window.sessionStorage.getItem("serviceName");
  var xmppUser = $window.sessionStorage.getItem('userXmpp');

  $scope.result = ''
  $scope.options = {};
  $scope.initialAddress = null;
  //$scope.data = null;
  $scope.selectedItem  = null;
  $scope.searchText    = null;
  //$scope.querySearch   = querySearch;
  $scope.request    = null;
  //$scope.theme = theme.getTheme();

  $scope.closeDialog = function(){
    $mdDialog.cancel();
  };

  $scope.submitAddress = function(){
    $scope.progressCircular = "ok";
    if($scope.details === undefined)
        $scope.msgToast("Debe ingresar la dirección completa y seleccionarla de la lista", "error-toast");
    else{
      var location = {};
      location.longitude = $scope.details.geometry.location.lng().toString();
      location.latitude = $scope.details.geometry.location.lat().toString();
      location.addressLine = $scope.details.formatted_address;
      location.label = "HOME";
      location.locality = $scope.details
      for(var i=0; i<$scope.details.address_components.length; i++)
      {
        if($scope.details.address_components[i].types[0] == "locality")
           location.locality = $scope.details.address_components[i].long_name;
        if($scope.details.address_components[i].types[0] == "postal_code")
           location.postalCode = $scope.details.address_components[i].long_name;
        if($scope.details.address_components[i].types[0] == "country"){
          location.country = $scope.details.address_components[i].short_name;
          location.countrycode = $scope.details.address_components[i].short_name;
          location.identifier = 0;
        }
     }
      services.userLocation('bearer ' + $window.localStorage.getItem('access_token1')).request({}, location,  function(status, response) {
          $scope.progressCircular = undefined;
          $mdDialog.cancel();
          var meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
          if(meta && meta.confirmation) {             
            $scope.showConfirmation();
            $scope.pendingSend = function() {
              xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, "HOME", $scope.details.formatted_address, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);          
              $localStorage.typeSelect = "value";
            }
         } else { 
            xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, "HOME", $scope.details.formatted_address, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);          
            $localStorage.typeSelect = "value";
         }
      });
    }
  }
  $scope.pendingSend = function(){};
  $scope.showConfirmation = function(ev) {
    var confirmDialog= $window.sessionStorage.getItem("confirmDialog");  
    confirmDialog.response = $scope.pendingMessage.value;
    $window.sessionStorage.setItem("confirmDialog", confirmDialog);       

   $mdDialog.show({
        controller: 'confirmationCntrl',
        templateUrl: './views/dashboard/confirmation.html',
        parent: angular.element(document.body),
        targetEvent: ev
    }).then(function(answer) {
            $scope.pendingSend();
      }, function() { 
    });
  };
  
  $scope.sendMsgPlace = function(msg) {
      if(msg === undefined)
        $scope.msgToast("Debe seleccionar su respuesta de la lista.", "error-toast");
      else {
        meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
        if(meta && meta.confirmation) {   
          $scope.pendingMessage = msg;
          $scope.showConfirmation();
          $scope.pendingSend = function() {
            xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, $scope.pendingMessage, $scope.pendingMessage, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
            $scope.selectedItem  = undefined;
            $scope.searchText    = undefined;
            $scope.showListText    = false;
            $window.sessionStorage.removeItem("confirmDialog");
          }
        } else { 
          xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg, msg, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
          $scope.selectedItem  = undefined;
          $scope.searchText    = undefined;
          $scope.showListText    = false;
      }
    }
  };

  $scope.msgToast = function(message, type){
    $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };
  $('.main1').scroll(function(eventObject ){
      var scrollTop = $('.main1').scrollTop()
     

      if($scope.showListText){
        var pos = cumulativeOffset(inputText) 
       
        list.style.top = pos.top + pos.height + "px";
        list.style.width = pos.width + "px";
        list.style.left = pos.left + "px";
        list.style.minWidth = "0px";
        if((pos.top + pos.height) < 150) {
          list.style.display = "none";
        } else {
          list.style.display = "block";
        }
        console.log(`Top: ${list.style.top}`);

      }
  })
  var cumulativeOffset = function(element) {
    var top = 0, left = 0;
    var height = element.offsetHeight;
    var width = element.offsetWidth;
    do {
       
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while(element);
    var scrollTop = $('.main1').scrollTop()
    return {
        top: top - scrollTop,
        left: left,
        width: width,
        height: height
    };
};
  $scope.showListText = false;
  var inputText = null;
  var list = null;
  $scope.querySearch = function (query, data, index) {
    
    if(query!=undefined && query.length>0) {
      $scope.notificationform.chat = true;
      inputText = document.getElementById("autocompleted" + index)     
      var pos = cumulativeOffset(inputText)
      list = document.getElementById("ulAutocomplete" + index)

      list.style.top = (pos.top - pos.height + 5) + "px";
      list.style.width =pos.width + "px";
       list.style.left = (pos.left - pos.width) + "px";
      //list.style.minWidth = "0px";
      $scope.showListText = true;
    }
    else
      $scope.showListText = false;
    $scope.selectedItem  = null;
    if(query && query != ""){
      var countryCodeText = "";
      var missingLabelCountry ="";
      var missingLabelState ="";
      var needState = false;
       

      if(data.addressType === 'STATE'){
        if($scope.showListText == false){
          $window.sessionStorage.removeItem("addrressStateCode");
        }
        for(var i=0 ; i<data.filters.length;i++){
          if(data.filters[i].name === 'countryCode'){
            countryCodeText = data.filters[i].value;
            missingLabelCountry = data.filters[i].missingLabel;
            break;              
          }
        }
      }
      else
        if(data.addressType === 'CITY' || data.addressType === 'AREA'){
          for(var i=0 ; i<data.filters.length;i++){
            if(data.filters[i].name === 'countryCode'){
              countryCodeText = data.filters[i].value;
              missingLabelCountry = data.filters[i].missingLabel;           
              
            }
            else
              if(data.filters[i].name === 'state'){
                needState = false;
                $window.sessionStorage.setItem("addrressStateCode", "STATE");
                missingLabelState = data.filters[i].missingLabel;           

              }
          }

        }

        if(countryCodeText === '' || countryCodeText.includes('{')){
          $scope.bodyItem.metadata.defaultValue = "";
          dialogMsg(missingLabelCountry);
          return;
        }

        if(needState && ($window.sessionStorage.getItem("addrressStateCode") ==undefined | $window.sessionStorage.getItem("addrressStateCode") == null )){
          $scope.bodyItem.metadata.defaultValue = "";
          $scope.showListText = false;
          dialogMsg(missingLabelState);
          return;
        }
      var jsonParams = {search: query, countryCode: countryCodeText, areaType: data.addressType};

      if(data.filters && data.filters.length>0){
        for( var i = 0; i<data.filters.length; i++){
          jsonParams[data.filters[i].name] = data.filters[i].value;
        }
      }

      var allPlaces = services.placesNewRequest('bearer ' + $window.localStorage.getItem('access_token1'), jsonParams).place({ }, {}, function(status, response) {
        if(status.code === -60)
          $scope.request = null;
      });


      var algo = $q.all([
          allPlaces.$promise
      ]);
      
      
      algo.then(function(response) {
          if(response[0].data && response[0].data.location){
            //$scope.data = data[0].data.location;
            $scope.request = response[0].data.location;
          }
      }).catch(function(err){
          console.log("error in search");
      });
    }
    else{
      if(data.addressType === 'STATE'){       
          $window.sessionStorage.removeItem("addrressStateCode");
      }

    }
  };

  $scope.selectOption = function(data, valueType) {

    if($scope.bodyItem.metadata.constraints.addressType === 'STATE'){
      $window.sessionStorage.setItem("addrressStateCode", data.name);
    }

    var value = valueType == 'FULL' ?  data.fullName : data.name

    $scope.bodyItem.metadata.defaultValue = value
    $scope.selectedItem = data;
    $scope.notificationform.chat = false;  
  }

  
  var dialogMsg = function(message){
    $mdDialog.show(
    $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .title('Notificación')
        .textContent(message)
        .ariaLabel('Alert Dialog Demo')
        .ok('Ok')
    );
}

  /*document.addEventListener("click", (evt) => {
    const flyoutElement = document.getElementById("autocompleted");
    let targetElement = evt.target; // clicked element
    do {
        if (targetElement == flyoutElement) {
            document.getElementById("ulAutocomplete").style.display = "block";
            return;
        }
        targetElement = targetElement.parentNode;
    } while (targetElement);
    document.getElementById("ulAutocomplete").style.display = "none";
  });*/

  //Para componente de cities
  /*function querySearch (query, data) {
    var allPlaces = services.placesRequest('bearer ' + $window.localStorage.getItem('access_token1')).place({type: data.type}, {filterValue: '["'+query+'"]', countryCode: data.countryCode}, function(status, response) {
    });
    $q.all([
        allPlaces.$promise
    ]).then(function(data) {
        if(data[0].data && data[0].data.location){
          $scope.data = data[0].data.location;
          return data[0].data.location;
        }
    }).catch(function(err){
        console.log("error");
    });
  }*/  
});
